import { fetchFactory } from 'isotope-client'

export const createUser = (form) => fetchFactory('/rtv-users', { body: JSON.stringify(form), method: 'put' })
export const updateUser = (id, form) => fetchFactory(`/rtv-users/${id}`, { body: JSON.stringify(form), method: 'post' })
export const deactivateUser = (id) => fetchFactory(`/rtv-users/${id}/deactivate`, { method: 'post' })
export const reactivateUser = (id) => fetchFactory(`/rtv-users/${id}/reactivate`, { method: 'post' })
export const checkEmailExists = (email) => fetchFactory(`/rtv-users/check-email-exists?email=${email}`)
export const checkIdExists = (id) => fetchFactory(`/rtv-users/check-id-exists?id=${id}`)